import { getStoredLeadBrain, getStoredLeadEmail } from "../../../../lib/leadIdCookie";
import { parseLeadCaptureBotType } from "../modal/leadCaptureEmployeeOptions.js";

export function resolvePrefillEmail(searchParams) {
  const fromUrl = (
    searchParams.get("email")
    || searchParams.get("lead_email")
    || ""
  ).trim();
  if (fromUrl) {
    return fromUrl;
  }
  return getStoredLeadEmail() || "";
}

export function resolvePrefillBrain(searchParams) {
  return (
    parseLeadCaptureBotType(searchParams.get("brain"))
    || parseLeadCaptureBotType(searchParams.get("bot_type"))
    || parseLeadCaptureBotType(searchParams.get("lead_bot_type"))
    || getStoredLeadBrain()
  );
}
